$(document).ready(function () {
  /**
   * Mega menu hover behavior
   */
  let hoverTimeout;
  const megaMenus = document.querySelectorAll('.mega-menu');

  megaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      menu.setAttribute('open', '');
      menu.classList.add('is-hovered');
    });

    menu.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => {
        menu.removeAttribute('open');
        menu.classList.remove('is-hovered');
      }, 200); // Delay 200ms to prevent flickering
    });

    // Also handle click to open/close as fallback for mobile
    const summary = menu.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (window.innerWidth < 990) {
          // On mobile, toggle normally
          e.preventDefault();
          const isOpen = menu.hasAttribute('open');
          if (isOpen) {
            menu.removeAttribute('open');
            menu.classList.remove('is-hovered');
          } else {
            // Close other menus first
            megaMenus.forEach(m => {
              m.removeAttribute('open');
              m.classList.remove('is-hovered');
            });
            menu.setAttribute('open', '');
            menu.classList.add('is-hovered');
          }
        }
      });
    }
  });

  /**
   * Slider tabs - Homepage
   */
  // $('#Slider-tabs-collection li').click(function () {
  //   $('#Slider-tabs-collection li').removeClass('active');
  //   $(this).addClass('active');

  //   var id = '.' + $(this).data('tabs');
  //   $('.block__collection').removeClass('active');
  //   $(id).addClass('active');
  // });

  // function controlTabsCollection() {
  //   setTimeout(function () {
  //     var current_slide_number = $('.slider-tabs-title .slider-counter--current').html();
  //     var tab_id = '#Slide-tabs-collection-' + current_slide_number;
  //     $(tab_id).trigger('click');
  //   }, 300);
  // }

  // $('.slider-tabs-title .slider-buttons .slider-button').click(function () {
  //   controlTabsCollection();
  // });

  // $('#Slider-tabs-collection').scroll(function () {
  //   controlTabsCollection();
  // });

  $('#Slider-tabs-collection li').click(function () {
    $('#Slider-tabs-collection li').removeClass('active');
    $(this).addClass('active');

    var id = '.' + $(this).data('tabs');
    $('.block__collection').removeClass('active');
    $(id).addClass('active');

    var index = $(this).index();
    $('.tabs-title-dots .slider-dot').removeClass('active');
    $('.tabs-title-dots .slider-dot').eq(index).addClass('active');
  });

  function controlTabsCollection() {
    setTimeout(function () {
      var current_slide_number = parseInt($('.slider-tabs-title .slider-counter--current').html(), 10);
      var tab_id = '#Slide-tabs-collection-' + current_slide_number;
      $(tab_id).trigger('click');

      $('.tabs-title-dots .slider-dot').removeClass('active');
      $('.tabs-title-dots .slider-dot')
        .eq(current_slide_number - 1)
        .addClass('active');
    }, 300);
  }

  $('.slider-tabs-title .slider-buttons .slider-button').click(function () {
    controlTabsCollection();
  });

  $('#Slider-tabs-collection').scroll(function () {
    controlTabsCollection();
  });

  $('.tabs-title-dots .slider-dot').click(function () {
    var index = $(this).index() + 1;
    var tab_id = '#Slide-tabs-collection-' + index;

    $('.tabs-title-dots .slider-dot').removeClass('active');
    $(this).addClass('active');

    $(tab_id).trigger('click');
    $('.slider-tabs-title .slider-counter--current').html(index);
  });

  /**
   * Check Main menu is open
   */
  $('.header-wrapper .header').hover(function () {
    var open = $('.list-menu details[open]').length;
    if (open) {
      $(this).addClass('submenu-open');
    } else {
      $(this).removeClass('submenu-open');
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.header-wrapper .header').length) {
      $('.header-wrapper .header').removeClass('submenu-open');
    }
  });

  /**
   * Change tabs filters at mobile - PLP
   */
  $('details.mobile-facets__details').click(function () {
    //$('details.mobile-facets__details').not(this).removeClass('menu-opening').removeAttr('open');
  });

  /**
   * Set header height gap
   */
  function setHeaderHeight() {
    setTimeout(function () {
      document.documentElement.style.setProperty(
        '--header-height-gap',
        `${$('.header-wrapper .header').outerHeight() + 2}px`
      );
    }, 500);

    window.addEventListener('resize', setHeaderHeight);
  }
  setHeaderHeight();

  /**
   * Wrap first letter of heading new about us Title
   */
  setTimeout(function () {
    $('.page-layout__new-about-us .main-page-title').each(function () {
      let text = $(this).text().trim();
      let parts = text.split(/\s+/);

      if (parts.length > 0) {
        let firstWord = parts.shift();
        let rest = parts.join(' ');
        $(this).html('<span class="first-word">' + firstWord + '</span> ' + rest);
      }
    });
  }, 300);

  if (window.innerWidth < 990) {
    $('.footer-block__heading').click(function () {
      const $menu = $(this).closest('.footer-block--menu');
      const $ul = $menu.find('ul');

      if ($menu.hasClass('footer-menu-active')) {
        $ul.css('max-height', 0);
        $menu.removeClass('footer-menu-active');
      } else {
        $ul.css('max-height', $ul.prop('scrollHeight') + 'px');
        $menu.addClass('footer-menu-active');
      }
    });
  }

  $('.newsletter-form__field-wrapper .field__input').on('input', function () {
    const $input = $(this);
    const $field = $input.closest('.field');

    if ($input.val().trim().length > 0) {
      $field.css('opacity', '1');
    } else {
      $field.css('opacity', '0.3');
    }
  });

  $('.newsletter-form__field-wrapper .field__input').each(function () {
    const $input = $(this);
    const $field = $input.closest('.field');

    if ($input.val().trim().length > 0) {
      $field.css('opacity', '1');
    } else {
      $field.css('opacity', '0.3');
    }
  });

  let playTimeout;

  $('.leqee-video-slideshow, .leqee-video').on('mouseenter', '.leqee-video__media', function () {
    const $wrapper = $(this);
    const $poster = $wrapper.find('.leqee-video-section__poster');

    if ($poster.length) {
      $poster.trigger('click');

      playTimeout = setTimeout(() => {
        const video = $wrapper.find('video').get(0);
        if (video) {
          video
            .play()
            .then(() => {
              $poster.css('display', 'none');
            })
            .catch((err) => {
              if (err.name !== 'AbortError') {
                console.warn('Video play failed:', err);
              }
            });
        }
      }, 200);
    }
  });

  $('.leqee-video-slideshow, .leqee-video').on('mouseleave', '.leqee-video__media', function () {
    const $wrapper = $(this);
    const video = $wrapper.find('video').get(0);
    const $poster = $wrapper.find('.leqee-video-section__poster');

    // Cancel pending play
    clearTimeout(playTimeout);

    if (video) {
      video.pause(); // no need to handle promise for pause
    }

    if ($poster.length > 0) {
      $poster.css('display', 'block');
    }
  });

  $('.leqee-video-slideshow, .leqee-video').on('click', '.leqee-video__media video', function () {
    const video = this;
    const $wrapper = $(this).closest('.leqee-video__media');
    const $poster = $wrapper.find('.leqee-video-section__poster');

    if (video) {
      if (video.paused) {
        video
          .play()
          .then(() => {
            $poster.css('display', 'none');
          })
          .catch((err) => {
            if (err.name !== 'AbortError') {
              console.warn('Video play failed:', err);
            }
          });
      } else {
        video.pause();
        $poster.css('display', 'block');
      }
    }
  });

  window.addEventListener('unhandledrejection', function (event) {
    if (event.reason?.name === 'AbortError') {
      event.preventDefault(); // Silently suppress
    }
  });

  function updateSliderPadding() {
    const $title = $('.leqee-video-slideshow .multicolumn__title');
    const $wrapper = $('.leqee-video-slideshow .slider-mobile-gutter');

    if ($title.length && $wrapper.length) {
      const paddingLeft = parseFloat($title.css('padding-left')) || 0;
      const marginLeft = parseFloat($title.css('margin-left')) || 0;
      const totalLeft = paddingLeft + marginLeft;

      $wrapper.css('padding-left', totalLeft + 'px');
    }
  }

  updateSliderPadding();

  $(window).on('resize', function () {
    updateSliderPadding();
  });

  $('.product__description-wrapper').each(function () {
    var $desc = $(this).find('.product__description');
    var $readMore = $(this).find('.read-more');

    var lineHeight = parseFloat($desc.css('line-height')) || 20;
    var maxHeight = lineHeight * 2;

    $desc.addClass('measuring');
    var fullHeight = $desc[0].scrollHeight;
    $desc.removeClass('measuring');

    if (fullHeight <= maxHeight) {
      $readMore.hide();
    } else {
      $readMore.show();
      $readMore.text($readMore.data('read-more'));
    }
  });

  if ($('.product__description-wrapper .read-more').length) {
    $(document).on('click', '.product__description-wrapper .read-more', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $desc = $this.closest('.product__description-wrapper').find('.product__description');

      if ($desc.hasClass('expanded')) {
        $desc.removeClass('expanded');
        $this.text($this.data('read-more'));
      } else {
        $desc.addClass('expanded');
        $this.text($this.data('read-less'));
      }
    });
  }

  if ($('.product__info-wrapper').length) {
    var $firstAcc = $('.product__info-wrapper .product__accordion').first();
    $firstAcc.find('details').attr('open', true);
    $firstAcc.find('summary').attr('aria-expanded', 'true');
  }

  if ($('.packaging-image').length) {
    $('.packaging-image').on('click', function () {
      var fullImg = $(this).find('img').data('full');
      if (fullImg) {
        $('#packagingModalImg').attr('src', fullImg);
        $('#packagingModal').fadeIn();
        $('body').addClass('no-scroll');
      }
    });

    $('.close-modal, #packagingModal').on('click', function (e) {
      if (e.target === this) {
        $('#packagingModal').fadeOut();
        $('body').removeClass('no-scroll');
      }
    });
  }

  $('.verify-content .otp-input-main').on('input', function () {
    var $verifyContent = $(this).closest('.verify-content');
    if ($(this).val().length > 0) {
      $verifyContent.addClass('has-value');
    } else {
      $verifyContent.removeClass('has-value');
    }
  });

  $('.customer-add-address-btn, .add-address-form-wrapper .close-address-form').on('click', function () {
    var popupAddress = $('.add-address-form-wrapper');
    var popupAddressOverlay = $('.popup-address-form-overlay');
    popupAddress.toggleClass('active');
    popupAddressOverlay.toggleClass('active');
    $('body').toggleClass('no-scroll');
  });

  $('.edit-address-btn, .edit-address-form-wrapper .close-address-form').on('click', function () {
    var popupAddress = $('.edit-address-form-wrapper');
    var popupAddressOverlay = $('.popup-address-form-overlay');
    popupAddress.toggleClass('active');
    popupAddressOverlay.toggleClass('active');
    $('body').toggleClass('no-scroll');
  });

  var $inputRegisterPhone = $('.update-user-box .login-inputBox .input-box-content.mobile-no-inner input');

  if ($inputRegisterPhone.length) {
    var getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

    var firstDigit = '138';
    var remainingDigits = ('00000000' + getRandomInt(0, 99999999)).slice(-8);

    $inputRegisterPhone.val(firstDigit + remainingDigits);
  }

  var $originalWrapper = $('.add-cart-wrapper');

  if ($originalWrapper.length) {
    var $stickyContainer = $('<div class="sticky-add-to-cart"></div>');
    $('body').append($stickyContainer);

    var $footer = $('.footer');
    var $placeholder = null;
    var isStickyActive = false;

    function isVisible($el) {
      var rect = $el[0].getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function adjustFooterPadding() {
      if ($stickyContainer.hasClass('active')) {
        $footer.css('padding-bottom', $stickyContainer.outerHeight());
      } else {
        $footer.css('padding-bottom', 0);
      }
    }

    $(window)
      .on('scroll', function () {
        if (!isStickyActive && $originalWrapper[0].getBoundingClientRect().bottom < 0) {
          $placeholder = $('<div class="add-cart-placeholder"></div>').css({
            height: $originalWrapper.outerHeight(),
          });
          $originalWrapper.after($placeholder);
          $stickyContainer.append($originalWrapper);

          setTimeout(function () {
            $stickyContainer.addClass('active');
            adjustFooterPadding();
          }, 10);

          isStickyActive = true;
        }

        if (isStickyActive && $placeholder && isVisible($placeholder)) {
          $placeholder.after($originalWrapper);
          $stickyContainer.removeClass('active');
          $placeholder.remove();
          $placeholder = null;
          isStickyActive = false;
          adjustFooterPadding();
        }
      })
      .trigger('scroll');
  }

  if ($('.product-form__buttons').length && $('.shopify-payment-button__button').length) {
    var buyLabel = $('.product-form__buttons').data('buy-label');
    $('.shopify-payment-button__button').text(buyLabel);
  }

  $('.product__accordion').each(function () {
    var $accordionContent = $(this).find('.accordion__content');

    // Check if the accordion content has any child elements (not counting text or pseudo-elements)
    if ($accordionContent.children().length === 0) {
      $(this).hide(); // Hide the empty accordion
    } else {
      $(this).show(); // Make sure it stays visible if it has content
    }
  });

  if ($('.slideshow-with-text').length) {
    function updateProgressBarWidth() {
      $('.slideshow-with-text .slick-with-progressbar').each(function () {
        var $wrap = $(this);
        var $slider = $wrap.find('.slick-slideshow');
        var $cur = $slider.find('.slick-current .block__slideshow');
        if (!$cur.length) $cur = $slider.find('.block__slideshow').first();
        var w = $cur.length ? $cur.outerWidth(true) : $wrap.width();
        $wrap.find('.slider-progress-bar-wrapper').css({ maxWidth: w + 'px', width: '100%' });
      });
    }

    updateProgressBarWidth();
    $(document).on(
      'init afterChange setPosition breakpoint',
      '.slideshow-with-text .slick-slideshow',
      updateProgressBarWidth
    );
    $(window).on('resize', updateProgressBarWidth);

    document.addEventListener('shopify:section:load', function (e) {
      $(e.target).find('.slideshow-with-text').length && updateProgressBarWidth();
    });
    document.addEventListener('shopify:section:select', function (e) {
      $(e.target).find('.slideshow-with-text').length && updateProgressBarWidth();
    });
    document.addEventListener('shopify:block:select', function (e) {
      $(e.target).closest('.slideshow-with-text').length && updateProgressBarWidth();
    });
  }

  if ($('.pdp-intro').length && $('.pdp-intro .image-with-text__text.pdp-intro-description__2').length) {
    function applyJustify() {
      if (window.innerWidth <= 990) {
        return;
      }

      const $box = $('.pdp-intro-description__2');
      const $wrapper = $box.closest('.pdp-intro.type-material');
      const $items = $box.find('p');

      if ($items.length === 0) {
        return;
      }

      const firstTop = $items.first().position().top;
      let multiRow = false;

      $items.each(function () {
        if (Math.round($(this).position().top) !== Math.round(firstTop)) {
          multiRow = true;
        }
      });

      const moreThanOne = $wrapper.length > 1;
      const moreThanTwoItems = $items.length > 2;

      if (multiRow || moreThanOne || !moreThanTwoItems) {
        $box.css('justify-content', 'center');
      } else {
        $box.css('justify-content', 'space-between');
      }
    }

    applyJustify();
    $(window).on('resize', applyJustify);
  }

  if ($('.group-material-content').length && $('.pdp-intro-description__2').length) {
    function applyPosition() {
      const $group = $('.group-material-content');
      const count = $group.find('.pdp-intro.type-material').length;
      const isDesktop = window.innerWidth > 990;

      // toggle class
      if (count >= 3 && isDesktop) {
        $group.find('.pdp-intro.type-material').addClass('has-special-description');
      } else {
        $group.find('.pdp-intro.type-material').removeClass('has-special-description');
      }

      $group.find('.pdp-intro.type-material').each(function () {
        const $item = $(this);
        const $content = $item.find('.image-with-text__content').first();

        if ($item.hasClass('has-special-description')) {
          $content.css('padding-bottom', '');
          return;
        }

        const $desc = $item.find('.pdp-intro-description__2').first();
        if ($desc.length || window.innerWidth <= 990) {
          const h = $desc.outerHeight();
          $content.css('padding-bottom', h + 'px');
        } else {
          $content.css('padding-bottom', '');
        }
      });
    }

    applyPosition();

    $(window).on('resize', applyPosition);

    $('.group-material-content img').on('load', applyPosition);
  }

  // Coupon code copy
  $(document).on('click', '.coupon-code-copy svg', function () {
    const wrapper = $(this).closest('.coupon-code-copy');
    const code = wrapper.find('span').first().text().trim();
    navigator.clipboard.writeText(code);

    const toast = $('#couponToast');

    toast.addClass('show');

    setTimeout(() => {
      toast.removeClass('show');
    }, 500);
  });

  // Set bottom of dots and progress-bar for square template
  function updateProgressBarPosition() {
    var $parent = $('.slideshow-with-featured-collection.is-square-template');

    if ($parent.length === 0) return;

    var $childImg = $parent.find('.banner__media');
    var $targetProgress = $parent.find('.slider-progress-bar-wrapper');
    var $targetDots = $parent.find('.slideshow__controls');

    if ($(window).width() < 750) {
      $targetProgress.css('bottom', '');
      $targetDots.css('bottom', '');
      return;
    }

    var parentHeight = $parent.innerHeight();
    var childBottom = $childImg.position().top + $childImg.outerHeight();
    var distanceToBottom = parentHeight - childBottom;

    var posProgress = distanceToBottom - 4;
    var posDots = distanceToBottom + 40;

    $targetProgress.css('bottom', posProgress + 'px');
    $targetDots.css('bottom', posDots + 'px');
  }

  $(window).on('load', function() {
    setTimeout(updateProgressBarPosition, 100);
  });

  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      updateProgressBarPosition();
    }, 100);
  });
});
